export enum VIEW_ITEM_STATES {
    INITIALIZING = 'INITIALIZING',
    NOT_STARTED = 'NOT_STARTED',
    ACTIVE = 'ACTIVE',
    ENDING = 'ENDING',
    ENDED = 'ENDED',
}

export enum ITEM_STATES {
    NOT_STARTED_AUCTION = 'NOT_STARTED_AUCTION',
    NOT_STARTED_AUCTION_BIN = 'NOT_STARTED_AUCTION_BIN',
    NOT_STARTED_FIXED_PRICE = 'NOT_STARTED_FIXED_PRICE',
    ONGOING_AUCTION = 'ONGOING_AUCTION',
    ONGOING_AUCTION_BIN = 'ONGOING_AUCTION_BIN',
    ONGOING_FIXED_PRICE = 'ONGOING_FIXED_PRICE',
    ENDED_AUCTION_WITHOUT_BID = 'ENDED_AUCTION_WITHOUT_BID',
    ENDED_AUCTION_WITH_WINNING_BID = 'ENDED_AUCTION_WITH_WINNING_BID',
    ENDED_AUCTION_SOLD_THROUGH_PURCHASE_OFFER = 'ENDED_AUCTION_SOLD_THROUGH_PURCHASE_OFFER',
    ENDED_AUCTION_WITHOUT_WINNING_BID = 'ENDED_AUCTION_WITHOUT_WINNING_BID',
    ENDED_AUCTION_BIN_BOUGHT_AS_BIN = 'ENDED_AUCTION_BIN_BOUGHT_AS_BIN',
    ENDED_AUCTION_BIN_SOLD_THROUGH_PURCHASE_OFFER = 'ENDED_AUCTION_BIN_SOLD_THROUGH_PURCHASE_OFFER',
    ENDED_PURE_BIN_SOLD_THROUGH_PURCHASE_OFFER = 'ENDED_PURE_BIN_SOLD_THROUGH_PURCHASE_OFFER',
    ENDED_FIXED_PRICE = 'ENDED_FIXED_PRICE',
    ENDED_CANCELLED = 'ENDED_CANCELLED',
    UNKNOWN = 'UNKNOWN',
}
